import { closeAttachmentPreview } from 'owa-group-files-hub-adaptors';
import { FileType, lazyResetSxSViewStoreAction } from 'owa-group-files-hub-store';

export function closeRecentFileCardPreviewAction(fileType: FileType, actionSource: string): void {
    switch (fileType) {
        case FileType.ClassicAttachment:
        case FileType.CloudAttachment:
            closeAttachmentPreview(actionSource);
            break;
        case FileType.SharePointFile:
            lazyResetSxSViewStoreAction.importAndExecute(actionSource);
            break;
    }
}
